import { Alpine } from "./alpine.js";

import "./appearance";
import "./bookmarks";
import "./collapsible";
import "./hotkeys";
import "./nav";
import "./search";
import "./scroll-position";
import "./window-scroll";

Alpine.start();
